import { ROLE } from '../constants/roles.js';
/**
 * 权限判定的单一实现，前后端共用 —— 避免前端菜单显示逻辑和后端接口鉴权
 * 出现两套判断标准导致「菜单能看见但点进去 403」这类问题。
 */
export function hasPermission(held, required) {
    const list = Array.isArray(required) ? required : [required];
    return list.every((p) => held.includes(p));
}
/** 任一命中即可 */
export function hasAnyPermission(held, required) {
    return required.some((p) => held.includes(p));
}
/** 一人一角色（2026-09-22）：判断持有的角色是否是其中之一 */
export function hasRole(held, required) {
    if (!held)
        return false;
    return Array.isArray(required) ? required.includes(held) : held === required;
}
export function isAdmin(role) {
    return role === ROLE.ADMIN;
}
/** 类型收窄辅助，前端拿到 ApiResponse 后用它区分成功/失败分支 */
export function isApiSuccess(res) {
    return res.success === true;
}
//# sourceMappingURL=guards.js.map